import React from "react";
// Shared global classes (.profile-container, .checkmark, ...) still live here.
import "./ViewPhotoSamplePopup.scss";
import correctPhoto from "../../../assets/PhotographSample/correctPhoto.jpg";
import hatCovered from "../../../assets/PhotographSample/hat-covered.svg";
import sunGlass from "../../../assets/PhotographSample/sunglass-covered.svg";
import shadow from "../../../assets/PhotographSample/shadow-covered.svg";
import GuideModal, { GuideGrid } from "../../UI/GuideModal/GuideModal";

export interface IViewPhotoSamplePopupProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

const ViewPhotoSamplePopup = (props: IViewPhotoSamplePopupProps) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };

  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Guide for Photo Upload"
      titleId="photo-sample-popup-title"
      closeLabel="Close photo guide"
    >
      <GuideGrid
        items={[
          { src: correctPhoto, alt: "Example of a valid clear selfie photo", caption: "Take a selfie facing the camera with a clear background.", valid: true },
          { src: hatCovered, alt: "Invalid photo with hat covering face", caption: "Don’t wear a hat." },
          { src: sunGlass, alt: "Invalid photo with sunglasses", caption: "Don’t wear sunglasses." },
          { src: shadow, alt: "Invalid dark and blurry photo", caption: "Don’t click a dark and blurry photo." },
        ]}
      />
    </GuideModal>
  );
};
export default ViewPhotoSamplePopup;
